import {
    Dialog,
    Button,
    VStack,
    Text,
} from "@chakra-ui/react";

const SessionExpiredModal = ({
    open,
    onLogin,
}) => {
    return (
        <Dialog.Root
            open={open}
            closeOnEscape={false}
            closeOnInteractOutside={false}
        >
            <Dialog.Backdrop />

            <Dialog.Positioner
                display="flex"
                alignItems="center"
                justifyContent="center"
                px={{
                    base: 4,
                    md: 0,
                }}
                py={4}
            >
                <Dialog.Content
                    maxW="420px"
                    w="100%"
                    borderRadius="20px"
                    p={2}
                    mx="auto"
                >
                    <Dialog.Body py={8}>
                        <VStack
                            gap={5}
                            textAlign="center"
                        >
                            <Text
                                fontSize="24px"
                                fontWeight="700"
                                color="#071D54"
                            >
                                Session Expired
                            </Text>

                            <Text
                                color="gray.600"
                                fontSize="15px"
                                lineHeight="1.7"
                            >
                                Your session has expired for security reasons.
                                Please sign in again to continue using
                                Mogoma Partner.
                            </Text>

                            <Button
                                bg="#2453FF"
                                color="white"
                                w="100%"
                                h="48px"
                                borderRadius="12px"
                                fontWeight="600"
                                onClick={onLogin}
                                _hover={{
                                    bg: "#1E46D9",
                                }}
                            >
                                Login Again
                            </Button>
                        </VStack>
                    </Dialog.Body>
                </Dialog.Content>
            </Dialog.Positioner>
        </Dialog.Root>
    );
};

export default SessionExpiredModal;